import { MARKETING_API } from '@/constants/API';
import { request } from '@umijs/max';

//方案详情
export async function getSchemeDetails(id: string) {
  return request(`${MARKETING_API}/scheme/parameter/getSchemeDetails/${id}`);
}
